import { render, staticRenderFns } from "./SideBarRightFlatHeader.vue?vue&type=template&id=1d8f03f6&scoped=true"
import script from "./SideBarRightFlatHeader.vue?vue&type=script&lang=js"
export * from "./SideBarRightFlatHeader.vue?vue&type=script&lang=js"
import style0 from "./SideBarRightFlatHeader.vue?vue&type=style&index=0&id=1d8f03f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8f03f6",
  null
  
)

export default component.exports